<template>
  <div class="ar-meter" :class="'tone-' + use.tone">
    <div class="ar-meter-text">
      <span>{{ use.label }}</span>
      <span v-if="use.pct !== null" class="ar-meter-pct">{{ pctText }}</span>
    </div>
    <div
      v-if="use.pct !== null"
      class="ar-meter-bar"
      role="progressbar"
      :aria-valuenow="use.pct"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-label="`Storage used: ${use.label}`"
    >
      <span :style="{ width: (use.used ? Math.max(use.pct, 2) : 0) + '%' }"></span>
    </div>
    <div v-if="detail && (use.trash || use.tone === 'full')" class="ar-meter-note">
      <template v-if="use.tone === 'full'">Almost full. </template>
      <template v-if="use.trash">{{ formatSize(use.trash) }} of this is in the Trash.</template>
    </div>
  </div>
</template>

<script>
import { formatSize, storageUse } from "../archiveHelpers";

/** How much of a cabinet's storage is used, with a bar when it has a limit. */
export default {
  name: "ArchiveStorageMeter",
  props: {
    // { used, trash, quota } in bytes; quota null = no limit
    storage: { type: Object, default: null },
    // Also say how much is in the Trash, and when it's nearly full.
    detail: { type: Boolean, default: false },
  },
  computed: {
    use() {
      return storageUse(this.storage);
    },
    // A little use shows as "<1%" rather than "0%".
    pctText() {
      return this.use.pct === 0 && this.use.used ? "<1%" : `${this.use.pct}%`;
    },
  },
  methods: { formatSize },
};
</script>
